/* import __COLOCATED_TEMPLATE__ from './invite-to-company-admin-modal.hbs'; */
import { readOnly, or } from '@ember/object/computed';
import { computed } from '@ember/object';
import Component from '@ember/component';
import Validator from 'validator';
import { task } from 'ember-concurrency';
import { SH_ERROR_INDEX } from 'sh-www/utils/adapter-errors';
import { handleFormErrorOrModal } from 'sh-www/utils/handles-errors';

/** @module */
export default Component.extend({
  tagName: '',

  /** @type {Ember.computed} */
  firstNameValidator: computed('first_name', function() {
    if (this.get('first_name').length === 0) return 'This is a required field';
  }),

  /** @type {Ember.computed} */
  lastNameValidator: computed('last_name', function() {
    if (this.get('last_name').length === 0) return 'This is a required field';
  }),

  /** @type {Ember.computed} */
  emailValidator: computed('email', function() {
    if (!Validator.isEmail(this.get('email'))) return 'This must be a valid email address';
  }),

  /** @type {task} */
  loadTeamMembersTask: task(function* () {
    const company = yield this.get('loadTeamMembers')();
    const companySize = company.get('approvedEmployees.length') + company.get('invites.length');

    if (companySize === 0) {
      this.set('is_admin', true);
    }

    return companySize;
  }),

  genericError: readOnly(`errors.${SH_ERROR_INDEX.CUSTOM_ERROR_BODY}`),

  /** @type {task} */
  sendInviteTask: task(function* () {
    try {
      yield this.get('sendInvite')(this.getProperties(['first_name', 'last_name', 'email', 'is_admin']));
    } catch (e) {
      handleFormErrorOrModal(
        this,
        e,
        ['first_name', 'last_name', 'email', 'is_admin', SH_ERROR_INDEX.CUSTOM_ERROR_BODY, SH_ERROR_INDEX.CUSTOM_ERROR_CODE],
        false,
        'There was an error sending your invite. Please refresh and try again',
        'invite-to-company-admin-modal -- error sending invite.' + JSON.stringify(e)
      );
    }
  }),

  /** @type {string} */
  first_name: '',

  /** @type {string} */
  last_name: '',

  /** @type {string} */
  email: '',

  /** @type {boolean} */
  is_admin: false,

  /** @type {Ember.computed} */
  loading: readOnly('loadTeamMembersTask.isRunning'),

  /** @type {Ember.computed} */
  submitDisabled: or('loadTeamMembersTask.isRunning', 'sendInviteTask.isRunning'),

  /** @type {Ember.computed} */
  adminButtonDisabled: computed('loadTeamMembersTask.last.value', function() {
    const companySize = this.get('loadTeamMembersTask.last.value');

    return !companySize;
  }),

  /** @inheritDoc */
  init() {
    this._super(...arguments);
    this.set('errors', { });
  },

  /** @inheritDoc */
  didInsertElement() {
    this._super(...arguments);
    this.get('loadTeamMembersTask').perform();
  },

  /** @inheritDoc */
  actions: {
    /**
     * @param {string} field
     * @param {string} value
     */
    handleChange(field, value) {
      this.setProperties({ [field]: value, [`errors.${field}`]: undefined });
    },

    /**
     * @param {string} field
     * @param {string} validator
     */
    handleBlur(field, validator) {
      this.set(`errors.${field}`, this.get(validator));
    },

    /**
     *
     */
    toggleAdmin() {
      this.toggleProperty('is_admin');
    },

    /**
     *
     */
    handleCancel() {
      this.get('handleCancel')();
    },

    /**
     *
     */
    handleSubmit() {
      const inviteTask = this.get('sendInviteTask');

      if (inviteTask.isRunning) {
        return;
      }

      const errors = [
        ['first_name', 'firstNameValidator'],
        ['last_name', 'lastNameValidator'],
        ['email', 'emailValidator'],
      ].reduce((accum, [field, validator]) => {
        const error = this.get(validator);

        if (error) {
          (accum || (accum = { }))[field] = error;
        }

        return accum;
      }, null);

      this.set('errors', errors || { });

      if (!errors) {
        inviteTask.perform();
      }
    },
  },
});
